/**
 * @generated SignedSource<<121a234e3c42e43630d3846a3d8011b5>>
 * @relayHash dbfc9d0488d8e5e091eefb3079672d20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f7f49d064b1a3432b1db263547373bb9b1f98e92deeac78186cacff76fb384c3

import type { ConcreteRequest } from 'relay-runtime';
export type PageAgentSessionNudgesQuery$variables = {
  aqlQuery: string;
  first: number;
  shardingContext: string;
};
export type PageAgentSessionNudgesQuery$data = {
  readonly agent_sessionAssociationQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agentSession: {
        readonly agent: {
          readonly picture: AGG$URL;
        } | null;
        readonly conversationChannel: {
          readonly id: string | null;
          readonly name: string | null;
          readonly readStatus: boolean | null;
        } | null;
        readonly id: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type PageAgentSessionNudgesQuery = {
  response: PageAgentSessionNudgesQuery$data;
  variables: PageAgentSessionNudgesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shardingContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "shardingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "picture"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "workspaceAri",
      "variableName": "shardingContext"
    }
  ],
  "concreteType": "AgentConversationChannel",
  "kind": "LinkedField",
  "name": "conversationChannel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "readStatus"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dbfc9d0488d8e5e091eefb3079672d20",
    "id": "f7f49d064b1a3432b1db263547373bb9b1f98e92deeac78186cacff76fb384c3",
    "metadata": {},
    "name": "PageAgentSessionNudgesQuery",
    "operationKind": "query",
    "text": "query PageAgentSessionNudgesQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{agentSession{id,agent{__typename,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:[\"AgentConversationChannelTeamEu26DemoOnly\"]){id,name,readStatus}},id}}}"
  }
};
})();

(node as any).hash = "9c8451dadb496a292acb18c35e3614ad";

export default node;
